const select = () => {
  return {
    MuiSelect: {
      styleOverrides: {
        // Single source of truth for Select height across the whole app.
        // MUI's own base styles apply padding via the compound class
        // ".MuiSelect-select.MuiOutlinedInput-input", which has higher
        // specificity than the plain ".MuiOutlinedInput-input" override in
        // input.js — so without overriding it here too, every <Select> ends
        // up rendering at whatever MUI's own default padding is, ignoring
        // ours. 48px matches MuiOutlinedInput.root in input.js, which itself
        // matches the 48px MuiTextField forces on every TextField — keep all
        // three in sync or Selects/OutlinedInputs will drift out of line
        // with the TextFields sitting next to them again (Country vs
        // State/Zip, Select Role vs Full Name/Email, etc.).
        select: ({ theme }) => ({
          minWidth: '6rem !important',
          fontSize: theme.typography.body1.fontSize,
          fontFamily: theme.typography.fontFamily,
          color: theme.palette.text.primary,
          // !important on every property here, not just minHeight: MUI's own
          // base style for this exact slot is the compound class
          // ".MuiSelect-select.MuiOutlinedInput-input", which ties this rule
          // on raw specificity (both are 2 classes) — a tie that isn't
          // guaranteed to resolve in our favor depending on style injection
          // order, which is exactly why some Selects (Audience Omnichannel
          // Settings) kept rendering at MUI's default size while others
          // (Country, Sex) only looked right because they ALSO had their own
          // per-page sx height override masking the same underlying problem.
          '&:not(.MuiTablePagination-select)': {
            height: '48px !important',
            minHeight: '48px !important',
            boxSizing: 'border-box !important',
            display: 'flex !important',
            alignItems: 'center !important',
            padding: '12px 32px 12px 12px !important'
          },
          '&.MuiTablePagination-select': {
            minWidth: '1.5rem !important'
          },
          '&.Mui-disabled ~ .MuiOutlinedInput-notchedOutline': {
            borderColor: `rgba(${theme.palette.customColors.main}, 0.22)`
          }
        })
      }
    }
    // NOTE: MuiOutlinedInput styling (background, height, border colors) lives
    // solely in input.js. Do NOT add a MuiOutlinedInput key here — the theme
    // is built with Object.assign(..., input, select, ...) in overrides/index.js,
    // which shallow-merges top-level keys. A MuiOutlinedInput key here would
    // silently replace (not merge with) input.js's version, wiping out the
    // white background every Select/OutlinedInput field relies on.
  }
}

export default select
